<template>
    <div>
        <div class="d-flex justify-content-between mb-4">
            <div>
                <h1 class="mb-0">Time Sheets</h1>
            </div>
            <div v-if="_hasAccess('setting.time_sheet.add')">
                <button
                    type="button"
                    class="btn"
                    style="background-color: #e1e1e1"
                    @click="AddNewClicked"
                >
                    Add New
                </button>
            </div>
        </div>
        <div v-if="!isLoading">
            <staff-view-timesheet-list
                :timesheets="timesheets"
                :isLoading="isLoading"
                :filter="filter"
                :totalPages="totalPages"
                @getTimesheets="getTimesheets"
                @updateTimesheetClicked="updateTimesheetClicked"
                @deleteTimesheetClicked="deleteTimesheetClicked"
                @staffNoteTimesheetClicked="staffNoteTimesheetClicked"
            />
        </div>
        <LoaderList v-else class="w-100" />
        <staffViewTimesheetModal
            ref="timesheetModal"
            :staffId="staffId"
            :selectedTimesheet="selectedTimesheet"
            @getTimesheets="getTimesheets"
            @emptySelectedTimesheet="emptySelectedTimesheet"
        />
        <staffViewTimesheetDeleteModal
            ref="timesheetDeleteModal"
            :selectedTimesheet="selectedTimesheet"
            @getTimesheets="getTimesheets"
            @emptySelectedTimesheet="emptySelectedTimesheet"
        />
        <staffViewTimesheetNoteModal
            ref="timesheetNoteModal"
            :staffId="staffId"
            :selectedTimesheet="selectedTimesheet"
            @getTimesheets="getTimesheets"
            @emptySelectedTimesheet="emptySelectedTimesheet"
        />
    </div>
</template>

<script>
import staffService from "@/services/staff";
import { get } from "lodash";

export default {
    components: {
        LoaderList: () => import("@/components/elements/loader-list.vue"),
        staffViewTimesheetList: () =>
            import("@/components/setting-staff/staff-view-timesheet-list.vue"),
        staffViewTimesheetModal: () =>
            import("@/components/setting-staff/staff-view-timesheet-modal.vue"),
        staffViewTimesheetDeleteModal: () =>
            import(
                "@/components/setting-staff/staff-view-timesheet-delete-modal.vue"
            ),
        staffViewTimesheetNoteModal: () =>
            import(
                "@/components/setting-staff/staff-view-timesheet-note-modal.vue"
            )
    },
    data() {
        return {
            filter: {
                perPage: 10,
                page: 1
            },
            totalPages: 0,
            isLoading: true,
            timesheets: [],
            selectedTimesheet: null
        };
    },
    computed: {
        details() {
            return this.$store.getters["staff/staffDetails"];
        },
        staffId() {
            return this.details && this.details.id;
        }
    },
    async created() {
        await this.getTimesheets();
    },
    methods: {
        async getTimesheets(page = null) {
            this.isLoading = true;

            this.emptySelectedTimesheet();

            if (page) {
                this.filter.page = page;
            }

            const res = await staffService.getTimesheets(
                this.staffId,
                this.filter.page,
                this.filter.perPage
            );

            const timesheets = get(res, "resource.data", []);
            const totalPages = get(res, "meta.lastPage", null);

            if (res.code && res.code == 200 && timesheets.length) {
                this.timesheets = timesheets;
                this.totalPages = totalPages;
            } else {
                this.timesheets = [];
            }

            this.isLoading = false;
        },
        AddNewClicked() {
            this.selectedTimesheet = null;
            this.$refs.timesheetModal?.$refs?.timesheetModal?.open();
        },
        updateTimesheetClicked(timesheet) {
            this.selectedTimesheet = timesheet;
            this.$refs.timesheetModal?.$refs?.timesheetModal?.open();
        },
        deleteTimesheetClicked(timesheet) {
            this.selectedTimesheet = timesheet;
            this.$refs.timesheetDeleteModal?.$refs?.timesheetDeleteModal?.open();
        },
        staffNoteTimesheetClicked(timesheet) {
            this.selectedTimesheet = timesheet;
            this.$refs.timesheetNoteModal?.$refs?.timesheetNoteModal?.open();
        },
        emptySelectedTimesheet() {
            this.selectedTimesheet = null;
        }
    }
};
</script>
